import React from 'react';
import MortgageTypes from './MortgageTypes';
import { content } from '../content';
import './MortgageTypesSection.css';

const MortgageTypesSection: React.FC = () => {
  return (
    <MortgageTypes 
      headline={content.mortgageTypes.headline}
      description={content.mortgageTypes.description}
      cards={content.mortgageTypes.cards}
    />
  );
};

export default MortgageTypesSection;
